export default ".wrapper {\n  position: relative;\n  min-height: 200px;\n  max-height: 80vh;\n  min-width: 300px;\n  overflow: auto;\n}";